module.exports = __webpack_public_path__ + "assets/images/rbyearend-01-desktop.jpg?v=51ff2c7d";